import { Link2, Coffee } from 'lucide-react'

const LINKEDIN = 'https://www.linkedin.com/in/mindful-abhay/'
const BUYMECOFFEE = 'https://buymeacoffee.com/abhaypratapsingh'

export function LinkedInLink({ className = '' }: { className?: string }) {
  return (
    <a 
      href={LINKEDIN} 
      target="_blank" 
      rel="noopener noreferrer"
      className={`link-prominent ${className}`}
    >
      <Link2 size={15} /> LinkedIn
    </a>
  )
}

export function BuyMeACoffeeLink({ className = '' }: { className?: string }) {
  return (
    <a 
      href={BUYMECOFFEE} 
      target="_blank" 
      rel="noopener noreferrer"
      className={`link-prominent border-[#c9a227] text-[#c9a227] hover:bg-[#c9a227]/10 hover:border-[#c9a227] ${className}`}
    >
      <Coffee size={15} /> Buy me a coffee
    </a>
  )
}

export function CreatorLinks({ variant = 'default' }: { variant?: 'default' | 'compact' | 'footer' }) {
  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-2">
        <LinkedInLink />
        <BuyMeACoffeeLink />
      </div>
    )
  }
  if (variant === 'footer') {
    return (
      <div className="flex flex-wrap items-center gap-x-4 gap-y-2 text-[12px] text-[#6b7280]">
        <span>Crafted with care by Abhay Pratap Singh</span>
        <span className="text-[#2a3146]">•</span>
        <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a227] transition-colors">LinkedIn</a>
        <a href={BUYMECOFFEE} target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a227] transition-colors">Buy me a coffee</a>
      </div>
    )
  }
  return (
    <div className="flex flex-wrap items-center gap-3">
      <LinkedInLink />
      <BuyMeACoffeeLink />
      <span className="text-[11px] text-[#6b7280] pl-1">Built by Abhay Pratap Singh</span>
    </div>
  )
}
